export default __webpack_public_path__ + "static/media/generic-icon.7df4547a.svg";